/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UploadConfigurationComponent} from './upload-configuration.component';

@NgModule({
    declarations: [UploadConfigurationComponent],
    exports: [
        UploadConfigurationComponent
    ],
    imports: [
        CommonModule
    ]
})
export class UploadConfigurationModule {
}
